import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { IAppliedFilter } from 'src/app/interface/applied-filter';
import { IFilterResponse } from 'src/app/interface/filter-response';
import { BuService } from 'src/app/services/http/bu.service';

@Component({
  selector: 'app-bu',
  templateUrl: './bu.component.html',
  styleUrls: ['./bu.component.scss']
})
export class BUComponent {
  appliedFilters: IAppliedFilter[] = []
  searchInput: string = '';
  public currentPage: number = 1;
  public pageSize: number = 10;
  public count: number = 0;
  public selectedBU: any =     {
    id: 0,
    name: '',
    longitude: 0,
    latitude: 0,
    address: '0'
  };
  public businessUnits : any [] =[]

  ngOnInit(): void {
    this.reloadTable();
  }  
  pageChange(value: number) {
    this.currentPage = value
    this.reloadTable()
  }


  constructor(private buService: BuService,
    private toastr: ToastrService) { }

  handleChangeFilter(appliedFilters: IFilterResponse){
    this.appliedFilters = appliedFilters.filters;
    this.searchInput = appliedFilters.searchFilter;
    this.currentPage = 1;
    this.reloadTable()
  }

  resetSelectedBU(){
    this.selectedBU = {
      id: 0,
      name: '',
      longitude: 0,
      latitude: 0,
      address: '0'
    };
  }

  reloadTable(page: any = null){
    if(page)
      this.currentPage = page;
      
    this.resetSelectedBU();

    let obj = {
      pageInfo:{
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      search : this.searchInput
    };

    this.buService.getAll(obj).subscribe(response => {
      console.log(response)
      this.businessUnits = response.data.data;
      this.count = response.data.count;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  selectBU(id : number){

  }
}
